import clsx from 'clsx';
import { useState, useEffect, useRef, useCallback } from "react";
import { NotificationService as Service } from 'app/notifications/services/notification.service';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { AlertItem } from './alert-item';
import { AlertEmpty } from './alert-empty';
import { toast } from 'react-toastify';
import { MyNotifications, NotificationModel } from 'app/notifications/model/notification.model';
import { useWebSocket } from '../signalR/context/signalR';

export function AlertsIcon() {
    const navigate = useNavigate();
    const initialData: MyNotifications = {
        notifications: []
    }

    const connection = useWebSocket();
    const [model, setModel] = useState<MyNotifications>(initialData);
    const menuRef = useRef<HTMLDivElement>(null);

    const alertsViewedPush = async (notification: NotificationModel) => {
        try {
            const result = await Service.markAsViewed({ notifications: [notification.id] });
            if (result == null || result.hasErrors) toast.error(result?.errorCode);
            const unreadNotifications = model.notifications.map(n => n.id == notification.id ? { ...notification } : n);
            setModel({ notifications: unreadNotifications });
        }
        catch (e) {
        }
    }

    const close = () => {
        if (!menuRef.current) return;
        menuRef.current.classList.remove("show");
    }

    const onNotified = useCallback(async () => {
        try {
            const result = await Service.getMyNotifications();
            if (result == null || result.hasErrors) {
                toast.error(result?.errorCode);
                return;
            };
            setModel(result.data);
        } catch (error) {
            console.error(error);
        }
    }, []);

    useEffect(() => {
        onNotified();
        if (!connection) return;
        const listeners: Function[] = [];
        listeners.push(connection.onNotify(onNotified));
        return () => listeners.forEach(l => l());
    }, [connection, onNotified]);

    return (
        <>
            <div
                className={clsx(
                    'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px position-relative',
                )}
                data-kt-menu-trigger={"click"}
                data-kt-menu-attach="parent"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="bottom"
                id="kt_drawer_chat_toggle"
            >
                <i className="fa-solid fa-bell"></i>
                {model?.notifications.filter(n => !n.read).length > 0 && (
                    <span className="bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink"></span>
                )}
            </div>

            <div
                className={clsx(
                    "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary py-4 fs-6 w-350px w-lg-375px",
                )}
                ref={menuRef}
                data-kt-menu="true"
            >
                <div className="menu-item px-3">
                    <div className="menu-content d-flex align-items-center justify-content-between py-3">
                        <h3 className="fw-semibold mb-0">
                            {`${t("alerts.notifications")}`}
                            <span className="fs-8 opacity-75 ps-3">
                                {model?.notifications.filter(n => !n.read).length} {`${t("alerts.noViewed")}`}
                            </span>
                        </h3>
                    </div>
                </div>

                <div className="separator my-2"></div>

                <div className="menu-item px-3">
                    <div className="scroll-y mh-325px my-2">
                        {model?.notifications.length > 0 ? (
                            model.notifications.map(n =>
                                <AlertItem notification={n} key={n.id} viewed={alertsViewedPush} onClick={close} />
                            )
                        ) : (
                            <AlertEmpty />
                        )}
                    </div>
                </div>

                <div className="separator my-2"></div>

                <div className="menu-item px-3 text-center">
                    <button
                        onClick={() => navigate("/notifications/center")}
                        className="btn btn-color-gray-600 btn-active-color-primary"
                    >
                        {`${t("alerts.viewAll")}`}
                    </button>
                </div>
            </div >
        </>
    );
}
